Vue.component("checkout-confirm-component", require("./Confirm.vue").default);
Vue.component("process-step-component", require("./ProcessStep.vue").default);
Vue.component("copy-url-component", require("./CopyUrl.vue").default);
Vue.component("checkout-sidebar-component", require("./Sidebar.vue").default);
Vue.component("paypal-component", require("./Paypal.vue").default);
